import moment from 'moment';

export default class Nfc {
  static nfcEnabled = {
    active: 1,
    disabled: 0
  };

  static nfcType = {
    card: 1,
    chip: 2,
    none: 0
  };

  constructor({
    rowNum,
    id,
    idType,
    userId,
    walletid,
    systemid,
    nfcinfo,
    reference,
    ATQA,
    SAK,
    ATR,
    UID,
    amount,
    status,
    updatedAt
  }) {
    this.rowNum = rowNum || null;
    this.id = id;
    this.idType = idType;
    this.userId = userId;
    this.walletid = walletid;
    this.systemid = systemid;
    this.nfcinfo = nfcinfo;
    this.reference = reference;
    this.ATQA = ATQA;
    this.SAK = SAK;
    this.ATR = ATR;
    this.UID = UID;
    this.amount = amount;
    this.status = status;
    this.updatedAt = updatedAt;
    this.expand();
  }

  expand() {
    let updatedAtFormatted = null;

    if (moment(this.updatedAt).isValid()) {
      updatedAtFormatted = moment(this.updatedAt).from();
    } else {
      updatedAtFormatted = null;
    }
    this.updatedAtFormatted = updatedAtFormatted;
  }

}
